import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const InitiativeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M7.488 9.288a.598.598 0 0 1 1.024 0l2.897 4.789c.317.525-.256 1.136-.795.847l-2.52-1.354a.2.2 0 0 0-.188 0l-2.52 1.354c-.54.289-1.113-.322-.795-.847z"
			clipRule="evenodd"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M13.5 7.998a5.5 5.5 0 1 0-10.31 2.668l.199.331.039.066a.75.75 0 0 1-1.25.816l-.045-.063-.131-.208a7 7 0 1 1 11.865.208l-.045.063a.75.75 0 0 1-1.21-.882l.198-.331c.44-.79.69-1.699.69-2.668"
			clipRule="evenodd"
		></path>
	</svg>
))
